import { BarChart3, CheckCircle2, Plug, ShoppingBag, Wallet } from "lucide-react";

/**
 * Estado "não conectada": o que a loja ganha, o que ela precisa ter e o
 * botão para começar. O passo a passo em si fica em PassoConexao.
 */
const GANHA = [
  [Wallet, "Quanto investiu", "O gasto de cada campanha, já com o imposto que a Meta cobra."],
  [ShoppingBag, "Quantos pedidos vieram", "Pedido do anúncio chega marcado no Kanban e em Pedidos."],
  [BarChart3, "Quanto voltou", "Faturamento, ROI e lucro por campanha, sem abrir o Gerenciador."],
];
const PRECISA = [
  "Página do Facebook da loja (todo anúncio sai em nome de uma Página)",
  "Instagram profissional ligado à Página",
  "Portfólio empresarial (Business Manager) da loja",
  "Conta de anúncio em reais, fuso de São Paulo, com Pix ou cartão",
];

export default function NaoConectada({ situacao, onComecar, podeGerir }) {
  const desfeita = situacao === "desfeita";
  return (
    <section className="rounded-xl border bg-card p-5 sm:p-6 space-y-5" data-e2e="meta-nao-conectada">
      <div>
        <h2 className="text-lg font-bold">{desfeita ? "A conexão foi desfeita" : "Conecte a conta de anúncios da loja"}</h2>
        <p className="text-sm text-muted-foreground mt-1 max-w-2xl">
          O Núcleo lê o gasto na Meta e cruza com os pedidos que vieram do anúncio.
          {desfeita && " O histórico de gasto ficou guardado; é só conectar de novo."}
        </p>
      </div>
      <div className="grid gap-3 sm:grid-cols-3">
        {GANHA.map(([Icone, titulo, texto]) => (
          <div key={titulo} className="rounded-lg bg-muted/40 p-3">
            <Icone className="w-5 h-5 text-sky-500" />
            <p className="text-sm font-semibold mt-2">{titulo}</p>
            <p className="text-xs text-muted-foreground mt-0.5">{texto}</p>
          </div>
        ))}
      </div>
      <div>
        <p className="text-sm font-semibold mb-2">O que a loja precisa ter</p>
        <ul className="grid gap-1.5 sm:grid-cols-2">
          {PRECISA.map((t) => (
            <li key={t} className="flex items-start gap-2 text-sm">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0" /> <span>{t}</span>
            </li>
          ))}
        </ul>
      </div>
      {podeGerir ? (
        <button onClick={onComecar} data-e2e="meta-comecar"
          className="inline-flex items-center gap-2 rounded-lg bg-primary text-primary-foreground px-4 py-2 text-sm font-semibold hover:opacity-90">
          <Plug className="w-4 h-4" /> Conectar com a Meta
        </button>
      ) : (
        <p className="text-xs text-muted-foreground">Só o proprietário ou um administrador pode conectar.</p>
      )}
    </section>
  );
}
